import { render, staticRenderFns } from "./NewContentFinished.vue?vue&type=template&id=688cef70"
import script from "./NewContentFinished.vue?vue&type=script&lang=js"
export * from "./NewContentFinished.vue?vue&type=script&lang=js"
import style0 from "./NewContentFinished.vue?vue&type=style&index=0&id=688cef70&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports